
 

<!-- Header Nav End --->
 <main>
	<div class="common-page logout">
		<div class="content">
			<img src=".././/.//../../assets/images/logout.png" alt="" />
			<h3>You have been logged out.</h3>
			<h4>Please sign in again.</h4>
			<p class="back-to">Back to <a href="https://www.myhcl.com" class="lineEffect">MyHCLTech</a></p>
		</div>
	</div>
</main>
<!-- Footer Start -->